import React from "react";
import http from "../http";
import PaginationComp from "../components/pagination.component";
import Spinner from "../components/UI/Spinner/Spinner.component";
import Article from "../components/article.list.component";
import queryString from "query-string";

class Archive extends React.Component {
  state = {
    monthOptions: [],
    articles: [],
    pageLimit: 15,
    currentPage: 1,
    totalCount: null,
    isLoading: true,
    selectedDuration: "",
    comments: [],
  };

  getMonths = async () => {
    const months = await http.get("/getMonths");
    this.setState({ monthOptions: months.data });
  };
  componentDidMount() {
    let date = new Date().toDateString();
    let dateArr = date.split(" ");
    let monthYear = `${dateArr[1]} ${dateArr[3]}`;
    this.getMonths();
    const { search } = this.props.location;
    const parseQuery = queryString.parse(search);
    this.getDataByParams(
      parseQuery.monthYear ? parseQuery.monthYear : monthYear,
      parseQuery.page ? parseQuery.page : 1
    );
  }

  getDataByParams = async (monthYear = null, page = 1) => {
    const { history, location } = this.props;
    history.push({
      pathname: location.pathname,
      search: `?monthYear=${monthYear}&page=${page}`,
    });
    this.setState({
      articles: [],
      isLoading: true,
      currentPage: page,
      selectedDuration: monthYear,
    });
    try {
      let params = {
        monthYear,
        page,
      };
      const response = await http.get("/getArticlesByMonths", {
        params,
      });
      this.setState({
        articles: response.data.results,
        pageLimit: response.data.pageLimit,
        totalCount: response.data.totalCount,
        isLoading: false,
        comments: response.data.comments,
      });
    } catch (err) {
      console.log(err);
    }
  };

  onPageChanged = (data) => {
    const currentPage = data;
    this.getDataByParams(this.state.selectedDuration, currentPage);
  };

  onchangeMonthOption = (e) => {
    let option = e.target.value;
    this.setState({ selectedDuration: option });
    this.getDataByParams(option);
  };
  render() {
    const {
      articles,
      totalCount,
      pageLimit,
      monthOptions,
      isLoading,
      currentPage,
      comments,
    } = this.state;
    let articleList = <Spinner />;
    if (articles.length) {
      articleList = articles.map((article) => {
        return (
          <Article
            key={article.Article_ID}
            article={article}
            isShowGroupHeading
            comments={comments}
          />
        );
      });
    } else if (!articles.length && !isLoading) {
      articleList = <h3> There is no data</h3>;
    }
    return (
      <div className="col-12 col-sm-12 col-md-8 col-lg-9">
        <div className="sectionTitle blueTitleBg clearfix d-flex py-2">
          <label className="align-top mx-2 mb-0">Previous Month: </label>
          <select
            className="custom-select w-25"
            value={this.state.selectedDuration}
            onChange={(e) => this.onchangeMonthOption(e)}
          >
            {!monthOptions.length
              ? null
              : monthOptions.map((month) => {
                  return (
                    <option key={month.MonthList} value={month.MonthList}>
                      {" "}
                      {month.MonthList}{" "}
                    </option>
                  );
                })}
          </select>
        </div>
        <div className="pageWrap p-3 bg-light shadow-sm">{articleList}</div>
        {!totalCount ? null : (
          <PaginationComp
            firstPageText={
              <i className="fa fa-angle-double-left" aria-hidden="true" />
            }
            lastPageText={
              <i className="fa fa-angle-double-right" aria-hidden="true"></i>
            }
            prevPageText={
              <i className="fa fa-chevron-left" aria-hidden="true" />
            }
            nextPageText={
              <i className="fa fa-chevron-right" aria-hidden="true" />
            }
            activePage={+currentPage}
            itemsCountPerPage={pageLimit}
            totalItemsCount={totalCount}
            onChange={this.onPageChanged}
            itemClass="page-item"
            linkClass="page-link"
          />
        )}
      </div>
    );
  }
}

export default Archive;
